
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col">
        <h4 class="modal-title">PC Acknowledgement</h4>
      </div>
    </div>
    <div class="modal-body">
      <div class="col">
        <div>You are acknowledging the source documentation have been validated and accurate before provider contracts are created.</div><br>
        <p> <b>Key Attributes</b></p>
        <div class="row">
          <div class="col-md-6">
            <p>Coterminous/Non-coterminous</p>
            <p>Billed in Arrears/Billed in Advance</p>
            <p>Billing Plan - Billing Frequency</p>
            <p>Base Rate</p>
            <p>Product Number</p>
            <p>Service SKU</p>
          </div>
          <div class="col-md-6">
            <p>Service SKU Rates</p>
            <p>Click and/or Supply Rates</p>
            <p>Currency - Solution</p>
            <p>Serial Number</p>
            <p>Provider Contract Start Date</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" title="Cancel" (click)="cancel()">No</button>
      <button class="btn btn-primary" type="button" title="Save changes" (click)="acknowledge()">Yes</button>
    </div>
  </div>
</div>